import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import settings from '../features/settings';
import userSlice from '../features/users';
import allOffers from '../features/offers';
import treaty from '../features/treaty';
import localForage from "localforage";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";


const persistConfig = {
  key: "@kava-root",
  storage: localForage,
};

const rootReducer = combineReducers({
  settings: settings,
  auth: userSlice,
  offers: allOffers,
  treaty: treaty
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
